<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกจุดขาย</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="host"
              >
                <option value="0">-- ทุกจุดขาย --</option>
                <option
                  v-for="(h, i) in host_list"
                  :key="'host' + i"
                  :value="h"
                >{{ h.host_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_bill_cancel.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="calItemAmountBranchAll(report_data) < 1"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_bill_cancel.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="calItemAmountBranchAll(report_data) < 1"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div
          class="text-center pt-3"
          v-if="report_data.length < 1"
        >
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div class="table-responsive-sm mt-3">

          <table
            id="sendMoney"
            class="table table-bordered"
            v-for="(c, i) in report_data"
            :key="'c' + i"
            v-show="c.length > 0"
          >
            <tbody>
              <tr style="background: #fffed4;">
                <th colspan="9">
                  <h4 class="m-1 p-1">
                    สาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}
                    &nbsp;&nbsp;&nbsp;&nbsp; จุดขาย: {{ (c[0])? c[0]['host_code'] || '-' : '-' }}
                  </h4>
                </th>
              </tr>
              <tr
                class="text-center"
                style="background: #ebf6ff;"
              >
                <th>ลำดับ</th>
                <th>เลขที่เอกสาร</th>
                <th>วันที่ เวลา</th>
                <th>ลูกค้า</th>
                <th>มูลค่าสินค้า</th>
                <th>ส่วนลด</th>
                <th>ผู้ยกเลิก</th>
                <th>วันเวลาที่ยกเลิก</th>
                <th>หมายเหตุบิล</th>
              </tr>
              <tr
                v-for="(c, i) in c"
                :key="'c' + i"
              >
                <td class="text-center">{{ numberFormat(i + 1) }}</td>
                <td class="text-left">{{ c.doc_no }}</td>
                <td class="text-left">{{ dateFormatAndTime(c.create_time) }} น.</td>
                <td class="text-left">{{ c.ar_name }}</td>
                <td class="text-right">{{ numberFormatDecimal(c.item_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(c.discount_amount) }}</td>
                <td class="text-left">{{ c.cancel_by }}</td>
                <td class="text-center">{{ dateFormatAndTime(c.cancel_time) }} น.</td>
                <td class="text-left">{{ c.description || '-' }}</td>
              </tr>
              <tr>
                <th colspan="4">รวมสาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}</th>
                <th class="text-right">{{ numberFormatDecimal(calItemAmount(c)) }}</th>
                <th class="text-right">{{ numberFormatDecimal(calDiscount(c)) }}</th>
                <th class="text-right"></th>
                <th class="text-right"></th>
                <th class="text-right"></th>
              </tr>
            </tbody>
          </table>
        </div>
        <table
          style="width: 100%;"
          v-if="calItemAmountBranchAll(report_data) > 0"
        >
          <tr style="background: #eeffeb; font-size: 20px;">
            <th
              class="pt-2 pl-2 pb-0"
            >
              รวมทุกสาขา:
            </th>
            <th class="text-right">มูลค่าสินค้า: {{ numberFormatDecimal(calItemAmountBranchAll(report_data)) }} บาท</th>
            <th class="text-right">ส่วนลด: {{ numberFormatDecimal(calDiscountBranchAll(report_data)) }} บาท</th>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>


<script>
import moment from 'moment'
import api from '../services/service_report'
import apipos from '../services/service_pos'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null
    }
  },
  methods: {
    getReport () {
      var branch = 0
      this.report_data = []
      this.form_data = ''
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        company_id: 1,
        host_code: this.host.host_code,
        branch_id: 1
      }
      this.$store.state.isLoading = true
      api.cancelBill(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(this.report_data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getReport()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    calQTY (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['qty']
      })
      return total
    },
    calItemAmount (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['item_amount']
      })
      return total
    },
    calDiscount (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['discount_amount']
      })
      return total
    },
    calItemAmountBranchAll (obj) {
      var total = 0
      obj.forEach(v => {
        v.forEach(val => {
          total += val['item_amount']
        })
      })
      return total
    },
    calDiscountBranchAll (obj) {
      var total = 0
      obj.forEach(v => {
        v.forEach(val => {
          total += val['discount_amount']
        })
      })
      return total
    }
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getBranch()
  }
}
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
</style>



// WEBPACK FOOTER //
// src/views/report_bill_cancel.vue